module.exports = __webpack_public_path__ + "img/partner-hover-6.fb7b54f1.png";